<template>
  <div class="bim-viewer h-100">
    <ERow ref="container" v-resize="updateFrameDimensions" no-gutters>
      <iframe
        ref="iframeCesium"
        :src="iframeSource"
        :style="iframeStyle"
        allowFullScreen="true"
        v-bind="$attrs"
        allow="clipboard-read; clipboard-write"
        v-on="$listeners"
        @load="updateFrameDimensions"
      ></iframe>
    </ERow>
  </div>
</template>

<script>
import { PERMISSIONS } from "@/constants/permissions"
import { DRONE_PROVIDERS } from "@evercam/shared/constants/droneProviders"
import { _3dFirebaseApi } from "@evercam/shared/api/3dFirebaseApi"

export default {
  meta: {
    requiredPermissions: [PERMISSIONS.SITE_VIEWS.VIEW],
  },
  name: "BimViewer",
  data: () => ({
    iframeStyle: {},
    droneData: null,
    integrationType: null,
  }),
  computed: {
    iframeSource() {
      const type = (this.$route.query.type || "").toLowerCase()
      switch (type) {
        case "cesium":
          return this.droneData &&
            this.integrationType !== DRONE_PROVIDERS.Evercam
            ? `${this.droneData.origin}/${this.droneData.params}`
            : `${this.$config.public.bimIframeUrl}/3d?projectID=${this.$route.params.exid}&type=site-view&user=admin`

        case "itwin":
          return `${this.$config.public.iTwinIframeUrl}/?projectID=${this.$route.params.exid}&type=site-view&user=admin`
        case "forge":
          return `${this.$config.public.forgeIframeUrl}/?projectID=${this.$route.params.exid}&type=site-view&user=admin`
        default:
          return `${this.$config.public.bimIframeUrl}/error`
      }
    },
  },
  async mounted() {
    this.updateFrameDimensions()
    await this.getDroneData()
  },
  methods: {
    async getDroneData() {
      try {
        const res = await _3dFirebaseApi.drone.getProjectInfo(
          this.$route.params.exid
        )
        if (res) {
          this.droneData = res
          this.integrationType =
            this.droneData.integrationType ?? DRONE_PROVIDERS.Evercam
        }
      } catch (err) {
        console.error(err)
      }
    },
    updateFrameDimensions() {
      const container = this.$refs.container?.$el?.getBoundingClientRect()
      this.$clearTimeouts()
      this.$setTimeout(() => {
        this.iframeStyle = {
          height: `${window.innerHeight - container?.top}px`,
          width: `${window.innerWidth - container?.left}px`,
        }
      }, 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.bim-viewer {
  &__main > v-sheet {
    height: 100vh;
  }
  .cesium-infoBox {
    display: none;
  }
}
</style>
